<template lang="pug">
  .content
    .content__block.content-docs
      h3.camp-content__subtitle При заезде в ДОЛ иметь:
      ul
        li(
        v-for="item in docs.split(';')"
        )
          p.camp-content__text {{item}}
</template>

<script>

export default {
  name: "CampDocs",
  props: {
    docs: {
      type: String,
      default: ""
    }
  }

};
</script>
